/* eslint-disable max-lines */
/* eslint-disable max-len */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import Storage from 'react-native-storage';

import CookieWarning from 'components/CookieWarning';
import MobileWarning from 'components/MobileWarning';
import SweetAlert from 'components/SweetAlert';

import APIHandler from 'config/APIHandler';
import AppSettings from 'config/AppSettings';
import DataHandler from 'config/DataHandler';
import locales from 'config/i18n';
import StorageHandler from 'config/StorageHandler';

import { ChaptersInfoProvider } from 'hooks/useChapters';
import { PointsHandlerProvider } from 'hooks/usePointsHandler';
import { SettingsProvider } from 'hooks/useSettings';
import { UserInfoProvider } from 'hooks/useUserInfo';

import AppRouter from 'routers/AppRouter';

// FontAwesome
import 'config/FontAwesome';
import 'normalize.css/normalize.css';
import 'assets/styles/sweetalert.css';
import './assets/styles/styles.scss';
import { contentKeys, language, storageKeys } from 'settings';

const { cookieEnabled } = window.navigator;

const exportObject = cookieEnabled
  ? new Storage({
    storageBackend: cookieEnabled ? window.localStorage : {},
    defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
    enableCache: true,
    sync: {
      // TODO: Handle exiration of data (Reload data with new API Calls)
    },
  })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

const availableLanguages = language
  .map(({ code }) => (typeof code === 'string' ? code : code.map((c) => c.toLowerCase())))
  .flat();
const commitRisk = language.some((lang) => lang.id === 220 && lang.countries.length > 0);
if (commitRisk) console.error('One of the testing languages is currently in use. Please remove before committing.');

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        }),
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.langFile]);
    });
    if (sessionStorage.getItem(sessionStorage.key('tt_sessionId')) !== '-1') {
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          const { email } = res;
          APIHandler.lastActive(appId, email);
          sessionStorage.setItem(sessionStorage.key('tt_sessionId'), -1);
        }
      });
    }
  });
  window.appId = appId;
});

const params = new URLSearchParams(window.location.search);
if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      if (params.get('market')) {
        let mobileLanguage = {
          country: 'United States',
          code: params.get('market'),
          langFile: 'en',
        };

        // Lang for mobile
        if (params.get('lang')) {
          mobileLanguage = {
            country: 'United States',
            code: params.get('market'),
            langFile: params.get('lang'),
          };
        }

        StorageHandler.save(storageKeys.lang, mobileLanguage);
      }
      StorageHandler.load(storageKeys.lang).then((res) => {
        i18n.setTexts(locales[res.langFile]);
      });
    } else {
      // Get user location and check if a language file exists.
      const languageData = {
        country: 'United States',
        code: 'US',
        langFile: 'en',
      };

      StorageHandler.save(storageKeys.lang, languageData);
      i18n.setTexts(locales.en);

      console.log(window.location.hostname);
      if (params.get('market')) {
        let mobileLanguage = {
          country: 'United States',
          code: params.get('market'),
          langFile: 'en',
        };

        // Lang for mobile
        if (params.get('lang')) {
          mobileLanguage = {
            country: 'United States',
            code: params.get('market'),
            langFile: params.get('lang'),
          };
        }

        StorageHandler.save(storageKeys.lang, mobileLanguage);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.de' ||
        window.location.hostname === 'www.usadiscoveryprogram.de'
      ) {
        const langDomain = {
          country: 'Germany',
          code: 'de',
          langFile: 'de',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.de);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.fr' ||
        window.location.hostname === 'www.usadiscoveryprogram.fr'
      ) {
        const langDomain = {
          country: 'France',
          code: 'fr',
          langFile: 'fr',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.fr);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.it' ||
        window.location.hostname === 'www.usadiscoveryprogram.it'
      ) {
        const langDomain = {
          country: 'Italy',
          code: 'it',
          langFile: 'it',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.it);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.kr' ||
        window.location.hostname === 'www.usadiscoveryprogram.kr'
      ) {
        const langDomain = {
          country: 'Korea',
          code: 'kr',
          langFile: 'ko',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.kr);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.mx' ||
        window.location.hostname === 'www.usadiscoveryprogram.mx'
      ) {
        const langDomain = {
          country: 'Mexico',
          code: 'mx',
          langFile: 'es',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.es);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.ca' ||
        window.location.hostname === 'www.usadiscoveryprogram.ca'
      ) {
        // Check browser language to determine if it should be French or English
        const userLang = navigator.language || navigator.userLanguage;

        let caCode = 'ca';
        let caCountry = 'Canada';

        if (userLang.includes('fr')) {
          caCode = 'FR-CA';
          caCountry = 'Canada - French';
        }

        const langDomain = {
          country: caCountry,
          code: caCode,
          langFile: userLang.startsWith('fr') ? 'fr' : 'en',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.en);
        window.location.reload();
      } else if (
        window.location.hostname === 'usadiscoveryprogram.com.br' ||
        window.location.hostname === 'www.usadiscoveryprogram.com.br'
      ) {
        const langDomain = {
          country: 'Brazil',
          code: 'br',
          langFile: 'pt',
        };
        StorageHandler.save(storageKeys.lang, langDomain);
        i18n.setTexts(locales.pt);
        window.location.reload();
      } else {
        APIHandler.getLocation().then((location) => {
          if (location && location.countryCode) {
            const code = location.countryCode.toLowerCase();
            let globalCode = code;
            if (
              [
                'ar',
                'bo',
                'cl',
                'co',
                'cr',
                'cu',
                'do',
                'ec',
                'sv',
                'gq',
                'gt',
                'hn',
                'mx',
                'ni',
                'pa',
                'py',
                'pe',
                'es',
                'uy',
                've',
              ].includes(code)
            ) {
              globalCode = 'es';
            }
            const availableLanguageForUserLocation = (translationFiles) =>
              translationFiles.map((translation) => translation === globalCode).includes(true);
            const [file] = language.filter(({ code: c }) => c.includes(globalCode)).map(({ langFile }) => langFile);

            if (availableLanguageForUserLocation(availableLanguages)) {
              if (globalCode == 'es') {
                StorageHandler.save(storageKeys.lang, {
                  country: location.country.replace(' ', '_'),
                  code: globalCode.toLowerCase(),
                  langFile: 'es',
                  // Actual country, so the API can tell Latin America (es-MX => es-la) from Spain (es-ES => es)
                  market: code,
                });
                window.location.reload();
              } else {
                StorageHandler.save(storageKeys.lang, {
                  country: location.country.replace(' ', '_'),
                  code: globalCode.toLowerCase(),
                  langFile: file[0],
                });
                window.location.reload();
              }
            } else {
              StorageHandler.save(storageKeys.lang, {
                country: location.country.replace(' ', '_'),
                code: location.countryCode.replace(' ', '_'),
                langFile: 'en',
              });
              window.location.reload();
            }
          } else {
            StorageHandler.save(storageKeys.lang, { country: 'United States', code: 'US', langFile: 'en' });
            i18n.setTexts(locales.en);
            window.location.reload();
          }
        });
      }
    }
  });
  StorageHandler.load('askedMobile').then((askedBefore) => {
    ReactDOM.render(<App askedBefore={askedBefore} />, document.getElementById('root'));
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    const { askedBefore } = this.props;

    this.state = {
      onMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent),
      askedBefore,
      loading: true,
      showLanguagePopup: false,
    };
  }

  componentDidMount() {
    this.setLoader();
    this.checkCanadianFrUser();
  }

  handleLanguageChange = ({ value = 'fr-ca', label = 'Canada - French' }) => {
    const code = value.toLowerCase();
    const [file] = language
      .filter(({ code: c, mainCode }) => c.includes(value) || (mainCode && mainCode.includes(value)))
      .map(({ langFile, code: c }) => langFile[c.indexOf(code)] || langFile[0]);
    StorageHandler.removeKeys(contentKeys);
    StorageHandler.remove(storageKeys.progress);
    StorageHandler.save(storageKeys.lang, {
      country: label,
      code: `${value}`.toUpperCase(),
      langFile: file,
    });

    window.location.reload();
  };

  setLoader() {
    AppSettings().then((res) => {
      if (res) {
        this.setState({ loading: false });
      }
      this.setState({ loading: false });
    });
  }

  checkCanadianFrUser() {
    const { hostname } = window.location;
    const userLang = navigator.language || navigator.userLanguage;

    // Check user's selected language
    const selectedLang = StorageHandler.load(storageKeys.lang).then((lang) => {
      if (lang && lang.code) {
        return lang.code;
      }
      return null;
    });

    selectedLang.then((langCode) => {
      if (
        (hostname === 'usadiscoveryprogram.ca' || hostname === 'www.usadiscoveryprogram.ca') &&
        userLang.startsWith('fr') &&
        (langCode === 'EN-CA'
        || langCode === 'ca') // Show popup only if langCode is 'En-Ca'
      ) {
        StorageHandler.load('languagePopupShown').then((popupShown) => {
          if (!popupShown) {
            this.setState({ showLanguagePopup: true });
          }
        });
      }
    });
  }

  render() {
    const { onMobile, askedBefore, loading, showLanguagePopup } = this.state;

    let header = true;
    if (params.get('header') === 'false') {
      header = false;
    }

    if (params.get('mobile') === 'true') {
      header = false;
    }

    if (window.location.pathname === '/register-mobile') {
      header = false;
    }

    if (window.location.pathname === '/register') {
      header = false;
    }

    if (window.location.href.includes('usadiscoveryprogram.cn')) {
      // Redirect after 3 seconds to article page
      setTimeout(() => {
        window.location.href = 'https://mp.weixin.qq.com/s/Sscz-otcS6j4LJD_NP8rwQ';
      }, 2000);
    }

    return (
      <div className="container__router">
        {loading && (
          <div className="appLoader">
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </div>
        )}
        {!loading && (
          <SettingsProvider>
            <UserInfoProvider>
              <ChaptersInfoProvider>
                <PointsHandlerProvider>
                  {!cookieEnabled && <CookieWarning />}
                  {header && onMobile && !askedBefore && (
                    <SweetAlert
                      trigger={onMobile}
                      {...{
                        title: '',
                        html: <MobileWarning />,
                        customClass: 'mobileWarning',
                        confirmButtonText: 'Continue >',
                        showConfirmButton: false,
                        onClose: this.setAsked,
                        closeOnClickOutside: false,
                        allowOutsideClick: false,
                      }}
                    />
                  )}

                  {showLanguagePopup && (
                    <SweetAlert
                      trigger={showLanguagePopup}
                      {...{
                        title: 'Programme disponible en français',
                        html: (
                          <div>
                            <h4>{"Nous avons remarqué que vous êtes situé(e) au Canada. Saviez-vous que le programme USA Discovery est aussi disponible en français ?"}
                              {"Souhaitez-vous passer à la version française du programme?"}
                            </h4>
                          </div>
                        ),
                        customClass: 'languagePopup',
                        confirmButtonText: 'Oui, passer en français',
                        showCancelButton: true,
                        cancelButtonText: 'Non, continuer en anglais',
                        onClose: (result) => {
                          if (result.isConfirmed) {
                            this.handleLanguageChange({ value: 'fr-ca', label: 'Canada - French' });
                          }
                          StorageHandler.save('languagePopupShown', true);
                        },
                        closeOnClickOutside: false,
                        allowOutsideClick: false,
                      }}
                    />
                  )}

                  {/* NOTE: Can't get optional chaining to work */}
                  {!loading && <AppRouter key={i18n && i18n.texts && i18n.texts.lang} />}
                </PointsHandlerProvider>
              </ChaptersInfoProvider>
            </UserInfoProvider>
          </SettingsProvider>
        )}
      </div>
    );
  }
}

App.propTypes = {
  askedBefore: PropTypes.bool.isRequired,
};
